module.exports = __webpack_public_path__ + "media/app/components/MainNav/DownloadIOSAppVi.816ec4c8.svg";